import type { ReactNode } from 'react';
import { WALLET_COLORS as C } from '@/constants';

export const GRID_FEATURE_TILE_STYLE = {
  borderColor: C.iconBorder,
  background: '#000000',
} as const;

/** Wallet FeatureGrid cell width — 4 columns, gap-2. */
export const FEATURE_TILE_GRID_CLASS = 'grid grid-cols-3 gap-2';

export function FeatureTileCell({ children }: { children: ReactNode }) {
  return <div className="w-full min-w-0">{children}</div>;
}

type GridFeatureTileProps = {
  label: string;
  icon?: string;
  labelColor?: string;
  onClick?: () => void;
  className?: string;
};

/** Square gold-border tile — wallet FeatureGrid + Me page grids. */
export function GridFeatureTile({
  label,
  icon,
  labelColor,
  onClick,
  className = '',
}: GridFeatureTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-2 py-3 flex min-h-0 min-w-0 flex-col items-center justify-center overflow-hidden gap-2 border rounded-xl active:opacity-70 ${className}`}
      style={GRID_FEATURE_TILE_STYLE}
    >
      {icon ? (
        <img src={icon} alt="" className="width-16 shrink-0 object-contain" draggable={false} />
      ) : null}
      <span
        className="flex w-full shrink-0 items-center justify-center text-center text-xs line-clamp-2"
        style={{ color: labelColor ?? C.text }}
      >
        {label}
      </span>
    </button>
  );
}
